import { c as _c } from "react/compiler-runtime";
import { colors, IconEmail } from '@newfront-insurance/core-ui';
import { cn } from '@newfront-insurance/core-ui/v2';
import { forwardRef, type JSX } from 'react';
import { getExtension, isKnownExtension } from '../../../utils/file';
interface Props {
  filename: string;
  colored?: boolean;
  hasBackground?: boolean;
  hasBoxShadow?: boolean;
  fileExtension?: string;
}
export function FileIcon(t0) {
  const $ = _c(23);
  const {
    filename,
    colored: t1,
    hasBackground: t2,
    hasBoxShadow: t3,
    fileExtension
  } = t0;
  const colored = t1 === undefined ? false : t1;
  const hasBackground = t2 === undefined ? true : t2;
  const hasBoxShadow = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== fileExtension || $[1] !== filename) {
    t4 = fileExtension ?? getExtension(filename);
    $[0] = fileExtension;
    $[1] = filename;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const extension = t4;
  const knownExtension = isKnownExtension(extension);
  if (!knownExtension) {
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <IconEmail color={colors.steel[400]} size={18} />;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    let t6;
    if ($[4] !== hasBackground || $[5] !== hasBoxShadow) {
      t6 = <IconContainer hasBackground={hasBackground} hasBoxShadow={hasBoxShadow}>{t5}</IconContainer>;
      $[4] = hasBackground;
      $[5] = hasBoxShadow;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    return t6;
  }
  let t5;
  if ($[7] !== extension) {
    t5 = extension?.toLowerCase();
    $[7] = extension;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const lowerCaseExtension = t5;
  let t6;
  if ($[9] !== colored || $[10] !== lowerCaseExtension) {
    t6 = colored && lowerCaseExtension && {
      "bg-fire-400": lowerCaseExtension === "pdf",
      "bg-brand-400": lowerCaseExtension === "doc" || lowerCaseExtension === "docx",
      "bg-grass-400": lowerCaseExtension === "xls" || lowerCaseExtension === "xlsx"
    };
    $[9] = colored;
    $[10] = lowerCaseExtension;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = cn("bg-steel-400 h-4 w-6 rounded-[2px] text-center", t6);
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== extension) {
    t8 = <span className="block text-center text-[8px] leading-[15px] font-bold text-white uppercase">{extension}</span>;
    $[14] = extension;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== hasBackground || $[20] !== hasBoxShadow || $[21] !== t9) {
    t10 = <IconContainer hasBackground={hasBackground} hasBoxShadow={hasBoxShadow}>{t9}</IconContainer>;
    $[19] = hasBackground;
    $[20] = hasBoxShadow;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
const IconContainer = forwardRef<HTMLDivElement, {
  hasBackground: boolean;
  hasBoxShadow: boolean;
} & React.PropsWithChildren>((t0, ref) => {
  const $ = _c(7);
  const {
    hasBackground,
    hasBoxShadow,
    children
  } = t0;
  const t1 = !hasBackground;
  let t2;
  if ($[0] !== hasBoxShadow || $[1] !== t1) {
    t2 = cn("bg-brand-100 dark:bg-background relative inline-flex aspect-square h-[42px] items-center justify-center rounded-xs", {
      "box-shadow-[0px_1px_4px_rgba(0,0,0,0.25)]": hasBoxShadow,
      "bg-transparent dark:bg-transparent": t1
    });
    $[0] = hasBoxShadow;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== ref || $[5] !== t2) {
    t3 = <div ref={ref} className={t2}>{children}</div>;
    $[3] = children;
    $[4] = ref;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
});
IconContainer.displayName = 'IconContainer';